import React, { useReducer } from 'react';
import PropTypes from 'prop-types';

import createNetworkingClient from 'utils/networking-client';

import AgeGateModal from '../../../../../apps/challenges/shared/components/AgeGateModal';
import { useFeedEntityContext } from '../../../state/FeedEntityContext';

import actions from './actions';
import reducer from './reducers';

const FeedEntryAgeGate = ({
  minimumAge,
  joinUrl,
  joinMethod,
  redirectUrl,
  currentAthlete,
  onUpdateDOB
}) => {
  const { locale } = useFeedEntityContext();

  const joinChallengeFn = () => {
    return createNetworkingClient()({
      method: joinMethod,
      url: joinUrl
    }).then(() => {
      window.location = redirectUrl;
    });
  };

  const [state, dispatch] = useReducer(reducer, {
    currentAthlete: null,
    gatingModal: {
      gatingConditions: { minimumAge },
      joinChallengeFn,
      ageGate: { dateSelected: new Date('1970-1-1') },
      requestInProgress: false
    }
  });

  const handleModalClose = () => dispatch({ name: actions.MODAL_CLOSE });
  const handleDateSelectionChange = (date) =>
    dispatch({ name: actions.MODAL_CHANGE_DATE, date });
  const handleDateUpdateInProgress = () =>
    dispatch({ name: actions.DOB_UPDATE_REQUESTED });
  const handleDateUpdateFailure = () =>
    dispatch({ name: actions.DOB_UPDATE_FAILED });
  const handleDateUpdateSuccess = (date) => {
    const serializedDate = [
      date.getFullYear(),
      date.getMonth() + 1,
      date.getDate()
    ].join('-');

    onUpdateDOB(serializedDate);

    const isTooYoung =
      new Date(date) >
      (() => {
        const d = new Date(new Date().toDateString());
        d.setFullYear(d.getFullYear() - minimumAge);
        return d;
      })();

    dispatch({
      name: actions.DOB_UPDATE_SUCCESS,
      dateOfBirth: serializedDate,
      isTooYoung
    });
  };

  const statefulAthlete = { ...currentAthlete, ...state.currentAthlete };

  return (
    <AgeGateModal
      {...{
        handleModalClose,
        handleDateSelectionChange,
        handleDateUpdateInProgress,
        handleDateUpdateSuccess,
        handleDateUpdateFailure,
        currentAthlete
      }}
      currentAthlete={statefulAthlete}
      gatingModal={state.gatingModal}
      locale={locale}
    />
  );
};

FeedEntryAgeGate.defaultProps = {
  onUpdateDOB: () => {}
};

FeedEntryAgeGate.propTypes = {
  minimumAge: PropTypes.number.isRequired,
  joinUrl: PropTypes.string.isRequired,
  joinMethod: PropTypes.string.isRequired,
  redirectUrl: PropTypes.string.isRequired,
  currentAthlete: PropTypes.shape({
    id: PropTypes.number.isRequired,
    dateOfBirth: PropTypes.string
  }).isRequired,
  onUpdateDOB: PropTypes.func
};

export default FeedEntryAgeGate;
